export default function RecipeMarquee() {
  const words = [
    "FAÇA VOCÊ MESMO",
    "SEM AÇÚCAR",
    "SEM GLÚTEN",
    "SEM LACTOSE",
    "COM COLÁGENO",
    "DO IT YOURSELF",
  ];
  const items = [...words, ...words, ...words];
  return (
    <section aria-hidden="true" className="border-y border-black overflow-hidden bg-white">
      <div className="py-6 md:py-8">
        <div className="marquee font-display text-3xl md:text-5xl uppercase tracking-[-0.01em]">
          {items.map((w, i) => (
            <span key={i} className="flex items-center gap-10">
              {w}
              <span className="w-2 h-2 bg-black inline-block rounded-full" />
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
